import { render, staticRenderFns } from "./ListCompanies.vue?vue&type=template&id=5c819f88"
import script from "./ListCompanies.vue?vue&type=script&lang=js"
export * from "./ListCompanies.vue?vue&type=script&lang=js"
import style0 from "./ListCompanies.vue?vue&type=style&index=0&id=5c819f88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports